const a = "_mark_hv0yo_1", s = {
  mark: a
};
export {
  s as default,
  a as mark
};
